module.exports = __webpack_public_path__ + "img/page-068.10d413d4.jpg";